import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';

import renderViewsState from '../../shared/render-views-state';
import Animate from '../../shared/animation';

import Form from '../components/form/large/main';

import { selectors as rootSelectors } from '../../root';

const Main = renderViewsState(
	props =>
		<Animate>
			<div className="container__content news-editor">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<Link to='news/' className="link">{ props.intl('Return to list of news') }</Link>
					</div>
					<div className="container__content-title-position">
						<h1 className="title">{ props.data ? props.data.title : props.intl('News editor') }</h1>
					</div>
				</div>
				<Form {...props} className="large" initialValues={props.formData.initialValues} enableReinitialize={true} />
			</div>
		</Animate>,
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		formData: selectors.getFormData(state),
		formLangs: selectors.getFormTabLangs(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		can: selectors.getCan(state),
		intl: selectors.getIntl(state),
		progressBar: selectors.getProgressBar(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/news/edit/main.js